import * as React from "react";
import { useEffect, useRef } from "react";
import classNames from "classnames";
import Portal from "../../Popups/Portal";
import { useMapContext } from "../../Contexts/MapContext";
import { usePrintContext } from "../../Contexts/PrintContext";

export const PrintFrame = (): JSX.Element => {
    const { printFrame } = useMapContext();
    const { format } = usePrintContext();

    const containerRef = useRef<HTMLDivElement>();
    const frameRef = useRef<HTMLDivElement>();

    useEffect(() => {
        if (!frameRef.current) {
            return;
        }

        frameRef.current.style.width = "100%";
        frameRef.current.style.height = "100%";

        if (!printFrame) {
            return;
        }
        const container = containerRef.current.getBoundingClientRect();
        const parentRatio = container.width / container.height;
        const pageRatio = format.value.includes("landscape") ? 1.65 : 0.75;

        frameRef.current.style.height =
            parentRatio > pageRatio ? "100%" : `${Math.round(container.width / pageRatio)}px`;

        frameRef.current.style.width =
            parentRatio > pageRatio ? `${Math.round(container.height * pageRatio)}px` : "100%";
    }, [printFrame, format]);

    return (
        <Portal id={"print-frame-container"}>
            <div className="frame-container" ref={containerRef}>
                <div id="print-frame" ref={frameRef} className={classNames({ visible: printFrame })} />
            </div>
        </Portal>
    );
};
